import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Panel } from "@/components/common";

const Field = ({ label, id, ...props }) => (
  <div className="space-y-2">
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} data-testid={`profile-${id}-input`} {...props} />
  </div>
);

function PasswordForm() {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Le password non coincidono");
    try {
      await api.put("/profile/password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password aggiornata");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <form onSubmit={submit} className="p-5 space-y-4">
      <Field label="Password attuale" id="current-password" type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
      <Field label="Nuova password (min. 8 caratteri)" id="new-password" type="password" required value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
      <Field label="Conferma nuova password" id="confirm-password" type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
      <Button type="submit" className="bg-blue-600 hover:bg-blue-500" data-testid="change-password-button">Cambia password</Button>
    </form>
  );
}

export default function Profile() {
  const { user, setUser } = useAuth();
  const c = user.client || {};
  const [f, setF] = useState({ name: user.name || "", contact_name: c.contact_name || "", phone: c.phone || "", address: c.address || "", pec: c.pec || "" });
  const isClient = user.role === "client";
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/profile", isClient ? f : { name: f.name });
      setUser(data);
      toast.success("Profilo aggiornato");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div>
      <PageHeader eyebrow="Account" title="Il mio profilo" desc={isClient ? "Aggiorna i tuoi dati di contatto e la password di accesso." : "Gestisci il tuo account amministratore."} />
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6">
        <Panel title="Dati profilo" testid="profile-panel">
          <form onSubmit={save} className="p-5 space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <Field label="Email di accesso" id="email" value={user.email} disabled />
              <Field label="Nome" id="name" value={f.name} onChange={set("name")} />
            </div>
            {isClient && (
              <>
                <div className="grid sm:grid-cols-2 gap-4">
                  <Field label="Ragione sociale" id="company" value={c.company_name || ""} disabled />
                  <Field label="Partita IVA" id="vat" value={c.vat_number || ""} disabled />
                </div>
                <div className="grid sm:grid-cols-2 gap-4">
                  <Field label="Referente" id="contact" value={f.contact_name} onChange={set("contact_name")} />
                  <Field label="Telefono" id="phone" value={f.phone} onChange={set("phone")} />
                </div>
                <Field label="Indirizzo" id="address" value={f.address} onChange={set("address")} />
                <Field label="PEC" id="pec" value={f.pec} onChange={set("pec")} />
              </>
            )}
            <Button type="submit" className="bg-blue-600 hover:bg-blue-500" data-testid="client-profile-save-button">Salva modifiche</Button>
          </form>
        </Panel>
        <Panel title="Cambia password" testid="password-panel"><PasswordForm /></Panel>
      </div>
    </div>
  );
}
